import { render, staticRenderFns } from "./AIModelCompanyList.vue?vue&type=template&id=bb4c1b64&scoped=true&"
import script from "./AIModelCompanyList.vue?vue&type=script&lang=js&"
export * from "./AIModelCompanyList.vue?vue&type=script&lang=js&"
import style0 from "./AIModelCompanyList.vue?vue&type=style&index=0&id=bb4c1b64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4c1b64",
  null
  
)

export default component.exports